import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { Link, withRouter } from 'react-router-dom';

import OneClickButton from '../../../../components/form/button';
import DualList from '../../../../components/pages/DualList';
import {
  Panel, PanelHeader, PanelBody, PanelFooter,
} from '../../../../components/panel/panel';
import addNotification from '../../../../components/notification';

import ROUTES from '../../../../config/routes';

import {
  createRangeRestriction, getRangeRestriction, updateRangeRestriction,
} from '../../../../app/store/actions/rangeRestriction';
import { getRangesOptions } from '../../../../app/store/actions/ranges';
import { getBranchesOptions } from '../../../../app/store/actions/branches';
import { getMaterialsFamilyOptions } from '../../../../app/store/actions/materialsFamily';

import Form from '../../../../components/form/form';

class RangeRestrictionsForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mode: 'detail',
      branchCode: '',
      branchName: '',
      name: '',
      materialFamilyCode: '',
      materialFamilyName: '',
      note: '',
      disableBranchCode: true,
      disableMaterialFamily: true,
      disableName: true,
      disableNote: true,
      showCreate: false,
      showUpdate: false,
      showCancel: false,
      listBranch: [],
      listMaterialFamily: [],
      selectedRangeRestrictions: [],

    };
  }

  async componentDidMount() {
    await this.setMode();
    await this.getOptions();
    if (this.state.mode !== 'create') {
      await this.getRangeRestrictionSelected();
    }
  }

  getRangeRestrictionSelected = async () => {
    if (this.props.location.state.rangeRestriction) {
      const { rangeRestriction } = this.props.location.state;

      const rangeRestrictionSelected = await this.props.getRangeRestriction(rangeRestriction.id);

      if (rangeRestrictionSelected) {
        this.setState({
          rangeRestrictionId: rangeRestrictionSelected.id,
          branchCode: rangeRestrictionSelected.branchCode,
          name: rangeRestrictionSelected.name,
          materialFamilyCode: rangeRestrictionSelected.materialFamily,
          materialFamilyName: rangeRestrictionSelected.materialFamilyName,
          selectedRangeRestrictions: rangeRestrictionSelected.rangeRestrictions,
          note: rangeRestrictionSelected.note,
        });
      }
    }
  };

  setMode = () => {
    let mode = '';
    if (this.props.isCreate) mode = 'create';
    else if (this.props.isCopy) mode = 'copy';
    else if (this.props.isEdit) mode = 'edit';
    else if (this.props.isDetail) mode = 'detail';

    if (mode === 'create' || mode === 'copy') {
      this.setState({
        mode,
        disableBranchCode: false,
        disableMaterialFamily: false,
        disableName: false,
        disableNote: false,
        showCreate: true,
        showUpdate: false,
        showCancel: true,
      });
    } else if (mode === 'edit') {
      this.setState({
        mode,
        disableBranchCode: true,
        disableMaterialFamily: true,
        disableName: false,
        disableNote: false,
        showCreate: false,
        showUpdate: true,
        showCancel: true,
      });
    }
  };

  setValue = async (attr, value) => {
    this.setState({
      [`${attr}`]: value,
    });
  };

  setValueDrop = async (attr, value) => {
    if (attr === 'branch') {
      const listRangeOptions = await this.props.getRangesOptions(value ? value.value : '');
      this.setState({ optionsRangeRestrictions: listRangeOptions });
    }
    await this.setState({
      [`${attr}Code`]: value ? value.value : '',
      [`${attr}Name`]: value ? value.label : '',
    });
  };

  getOptions = async () => {
    const listBranch = await this.props.getBranchesOptions();
    this.setState({ listBranch });

    const listMaterialFamily = await this.props.getMaterialsFamilyOptions();
    if (listMaterialFamily) {
      this.setState({ listMaterialFamily });
    }

    const { mainBranch } = await this.props.userLogged;
    const selectBranch = listBranch.find((element) => element.value === mainBranch);

    if (selectBranch) {
      const listRangeOptions = await this.props.getRangesOptions(selectBranch.value);
      this.setState({
        optionsRangeRestrictions: listRangeOptions,
        branchCode: selectBranch.value,
        branchName: selectBranch.label,
      });
    }
  };

  onChangeDualList = (selected, field) => {
    this.setState({ [field]: selected });
  };

  createRangeRestrictionSubmit = async () => {
    const {
      branchCode,
      name,
      materialFamilyCode,
      selectedRangeRestrictions,
      note,
    } = this.state;

    try {
      const newRangeRestriction = await this.props.createRangeRestriction({
        branchCode,
        name,
        materialFamily: materialFamilyCode,
        rangeRestrictions: selectedRangeRestrictions.join('|'),
        note,
      });

      if (newRangeRestriction) {
        await addNotification(
          'success',
          I18n.t('BEE4500' /* Restrição de Range */),
          I18n.t('BEE4513' /* Restrição de Range incluída com sucesso. */),
          'top-right',
        );

        this.props.history.push(ROUTES.RANGE_RESTRICTION_LIST);
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          await addNotification(
            'danger',
            I18n.t('BEE4500' /* Restrição de Range */),
            `${error.code} - ${error.details || error.message}`,
            'top-right',
          );
        } else {
          await addNotification(
            'danger',
            I18n.t('BEE4500' /* Restrição de Range */),
            I18n.t('BEE4505' /* Erro ao incluir Restrição de Range. */),
            'top-right',
          );
        }
      } else {
        await addNotification(
          'danger',
          I18n.t('BEE4500' /* Restrição de Range */),
          I18n.t('BEE4505' /* Erro ao incluir Restrição de Range. */),
          'top-right',
        );
      }
    }
  };

  updateRangeRestrictionSubmit = async () => {
    const {
      rangeRestrictionId, branchCode, materialFamilyCode, selectedRangeRestrictions, name, note,
    } = this.state;

    try {
      const updUser = await this.props.updateRangeRestriction({
        rangeRestrictionId,
        branchCode,
        name,
        materialFamily: materialFamilyCode,
        rangeRestrictions: selectedRangeRestrictions.join('|'),
        note,
      });

      if (updUser) {
        await addNotification(
          'success',
          I18n.t('BEE4506' /* Atualizar Restrição de Range */),
          I18n.t('BEE4507' /* Atualização da Restrição de Range efetuada com sucesso. */),
          'top-right',
        );

        this.props.history.push(ROUTES.RANGE_RESTRICTION_LIST);
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          await addNotification(
            'danger',
            I18n.t('BEE4506' /* Atualizar Restrição de Range */),
            `${error.code} - ${error.details || error.message}`,
            'top-right',
          );
        } else {
          await addNotification(
            'danger',
            I18n.t('BEE4506' /* Atualizar Restrição de Range */),
            I18n.t('BEE4508' /* Erro ao atualizar Restrição de Range. */),
            'top-right',
          );
        }
      } else {
        await addNotification(
          'danger',
          I18n.t('BEE4506' /* Atualizar Restrição de Range */),
          I18n.t('BEE4508' /* Erro ao atualizar Restrição de Range. */),
          'top-right',
        );
      }
    }
  };

  render() {
    const {
      mode, branchCode, branchName, materialFamilyCode, name, note, listBranch,
      materialFamilyName, listMaterialFamily,
      disableBranchCode, disableMaterialFamily, disableName, disableNote,
      showCancel, showCreate, showUpdate,
    } = this.state;

    let title = '';
    //   let breadActive = '';

    if (mode === 'create' || mode === 'copy') {
      title = I18n.t('BEE4502' /* Nova Restrição de Range */);
    } else if (mode === 'edit') {
      title = I18n.t('BEE4503' /* Editar Restrição de Range */);
    } else if (mode === 'detail') {
      title = I18n.t('BEE4504' /* Detalhes Restrição de Range */);
    }

    return (
      <div className="slideUpTransition">
        <div className="d-flex align-items-center">
          <ol className="breadcrumb float-xl-left">
            <li className="breadcrumb-item">
              <i className="fas fa-home fa-fw m-t-10 m-r-5" />
              {' '}
              {I18n.t('BEE12' /* Início */)}
            </li>
            <li className="breadcrumb-item">{I18n.t('BEE1389' /* Cadastros */)}</li>
            <li className="breadcrumb-item">{I18n.t('BEE14' /* Gerais */)}</li>
            <li className="breadcrumb-item">{I18n.t('BEE4500' /* Restrição de Range */)}</li>
            <li className="breadcrumb-item active">{I18n.t('BEE4502' /* Nova Restrição de Range */)}</li>
          </ol>
        </div>
        <div className="d-flex align-items-center mb-md-3 mb-2">
          <h1 className="page-header mb-0">
            {title}
          </h1>
        </div>
        <div className="row">
          <div className="col-xl-12 text-right">
            <form>
              <Panel>
                <PanelHeader noButton />
                <PanelBody>
                  <Form
                    noPanel
                    setValue={this.setValue}
                    setValueDrop={this.setValueDrop}
                    inputs={(formContext) => ([
                      formContext.createSelectDropDown(
                        { value: branchCode, label: branchName },
                        'branch',
                        `${I18n.t('BEE145' /* Filial */)}:`,
                        listBranch,
                        disableBranchCode,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        true,
                      ),
                      formContext.createSelectDropDown(
                        { value: materialFamilyCode, label: materialFamilyName },
                        'materialFamily',
                        `${I18n.t('BEE2668' /* Família Material */)}:`,
                        listMaterialFamily,
                        disableMaterialFamily,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        true,
                      ),
                      formContext.createInput(
                        name,
                        'name',
                        `${I18n.t('BEE83' /* Nome */)}:`,
                        I18n.t('BEE3718' /* Informe o nome */),
                        'text',
                        true,
                        disableName,
                      ),
                      formContext.createInput(
                        note,
                        'note',
                        `${I18n.t('BEE135' /* Observação */)}:`,
                        I18n.t('BEE136' /* Informe a observação */),
                        'text',
                        false,
                        disableNote,
                      ),
                      <DualList
                        id="dualselectinbounddeposit"
                        title={I18n.t('BEE4510' /* Restrição de Armazenamento */)}
                        availableHeader={I18n.t('BEE4511' /* Ranges Disponíveis */)}
                        selectedHeader={I18n.t('BEE4512' /* Ranges Selecionados */)}
                        filterPlaceholder={I18n.t('BEE541' /* Filtrar... */)}
                        options={this.state.optionsRangeRestrictions}
                        selected={this.state.selectedRangeRestrictions}
                        onChange={(item) => { this.onChangeDualList(item, 'selectedRangeRestrictions'); }}
                        disabled={(mode === 'detail')}
                      />,
                    ])}
                  />
                </PanelBody>
                <PanelFooter>
                  <Link to={{ pathname: ROUTES.RANGE_RESTRICTION_LIST, state: { dice: this.props.location.dice } }}>
                    {(showCancel
                      ? (
                        <OneClickButton
                          type="submit"
                          className="btn btn-120 btn-white p-5 m-5"
                        >
                          {I18n.t('BEE99' /* Cancelar */)}
                        </OneClickButton>
                      )
                      : (
                        <OneClickButton
                          type="submit"
                          className="btn btn-120 btn-white p-5 m-5"
                        >
                          {I18n.t('BEE137' /* Voltar */)}
                        </OneClickButton>
                      ))}
                  </Link>
                  {(showCreate
                    && (
                      <OneClickButton
                        type="button"
                        className="btn btn-120 btn-primary p-5 m-5"
                        onClick={() => this.createRangeRestrictionSubmit()}
                      >
                        {I18n.t('BEE138' /* Criar */)}

                      </OneClickButton>
                    )
                  )}
                  {(showUpdate
                    && (
                      <OneClickButton
                        type="button"
                        className="btn btn-120 btn-primary p-5 m-5"
                        onClick={() => this.updateRangeRestrictionSubmit()}
                      >
                        {I18n.t('BEE139' /* Atualizar */)}

                      </OneClickButton>
                    )
                  )}
                </PanelFooter>
              </Panel>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userLogged: state.app.userLogged,
});

const mapDispatchToProps = (dispatch) => ({
  getRangeRestriction: (rangeRestrictionId) => dispatch(getRangeRestriction(rangeRestrictionId)),
  createRangeRestriction: (rangeRestriction) => dispatch(createRangeRestriction(rangeRestriction)),
  updateRangeRestriction: (rangeRestriction) => dispatch(updateRangeRestriction(rangeRestriction)),
  getBranchesOptions: () => dispatch(getBranchesOptions()),
  getMaterialsFamilyOptions: () => dispatch(getMaterialsFamilyOptions()),
  getRangesOptions: (branchCode) => dispatch(getRangesOptions(branchCode)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RangeRestrictionsForm));
